<script>
import { i18n } from '@/i18n'
import sl from '@/Prevodi/SignaturePad-sl.json'
import en from '@/Prevodi/SignaturePad-en.json'
import it from '@/Prevodi/SignaturePad-it.json'
import SignaturePad from 'signature_pad'
export default {
  components: {
    // name: "SignaturePad",
  },
  props: {
    UserID: String,
    FullUser: Object,
  },
  emits: ['saved', 'dodajPodpis'],
  data() {
    return {
      prevodi: false,
      signaturePad: null,
      showPodpis: false,
      Refresh: '',
      refreshKey: Date.now(),
      windowWidth: window.innerWidth,
      File: null,
    }
  },
  created() {
    // await this.loadTranslations('sl', './src/prevodi/SignaturePad-sl.json');
    // await this.loadTranslations('en', './src/prevodi/SignaturePad-en.json');
    // await this.loadTranslations('it', './src/prevodi/SignaturePad-it.json');
    this.loadTranslationsDirekt('sl', sl);
    this.loadTranslationsDirekt('en', en);
    this.loadTranslationsDirekt('it', it);
    this.prevodi = true;
  },
  mounted() {
    this.getCanvas();
  },
  methods: {
    getCanvas() {
      this.$nextTick(() => {
        const canvas = this.$refs.canvas
        if (!canvas) return
        this.signaturePad = new SignaturePad(canvas, {
          penColor: "black",
          backgroundColor: "white",
          minWidth: 0.5,
          maxWidth: 2.5,
        })
      })
    },
    UpdateSignature() {
      this.refreshKey = Date.now();
    },
    clearSignature() {
      this.signaturePad.clear()
    },
    saveSignature() {
      if (this.signaturePad.isEmpty()) {
        alert("Podpis je prazen!")
        return null
      }
      const dataUrl = this.signaturePad.toDataURL("image/jpeg", 0.5);
      let podatki = new FormData();
      const blob = this.dataURItoBlob(dataUrl); //pretvorimo daraUrl v blob, da lahko pošljemo v API
      podatki.append('slikaUpload', blob, 'podpis.png');
      podatki.append('idU', this.UserID);
      axios.post('./api/upload/slike/', podatki, {withCredentials: true})
          .then((odgovor) => {
            this.File = odgovor.data.podatki;
            this.$emit('dodajPodpis', this.File);
            this.UpdateSignature();
            this.clearSignature();
          }).catch((napaka) => {
      });
      // tukaj lahko emit-aš event s podatki
      this.$emit("saved", dataUrl);
      return dataUrl
    },
    dataURItoBlob(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      var byteString = atob(dataURI.split(',')[1]);
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
      // write the bytes of the string to an ArrayBuffer
      var ab = new ArrayBuffer(byteString.length);
      // create a view into the buffer
      var ia = new Uint8Array(ab);
      // set the bytes of the buffer to the correct values
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      // write the ArrayBuffer to a blob, and you're done
      var blob = new Blob([ab], {type: mimeString});
      return blob;
    },
    OpenPodpis() {
      this.showPodpis = !this.showPodpis;
      if (this.showPodpis) {
        this.getCanvas();
      }
    },
    async loadTranslations(lang, path) {
      const response = await fetch(path);
      const json = await response.json();
      i18n.global.mergeLocaleMessage(lang, json);
      // this.$i18n.mergeLocaleMessage(lang, json);
    },
    loadTranslationsDirekt(lang, messages) {
      i18n.global.mergeLocaleMessage(lang, messages)
    },
    changeLang(lang) {
      i18n.global.locale.value = lang
    },
  }
}
</script>
<template>
  <!-- <div class="container"> -->
  <!--       <div class="drop-down-icon text-black" @click.prevent="OpenPodpis()">
            <i v-show="!showPodpis" class="fas fa-chevron-right"></i>
            <i v-show="showPodpis" class="fas fa-chevron-down"></i>
        </div>
        <button class="btn-prikaz-povzetka border-0 rounded-4 p-2 fs-5" type="text" id="Skupno" @click.prevent="OpenPodpis()">{{$t('labels.buttons.dodaj')}}</button> -->
  <transition name="fade">
    <div class="container p-4 gap-2" :class="{'d-flex justify-content-center': windowWidth > 480 }">
      <!-- <div class="container p-4 gap-2"> -->
      <canvas ref="canvas" class="border-2 border-secondary"></canvas>
      <div class="container row" :class="{'d-flex justify-content-between': windowWidth < 480}">
        <button
            class="btn btn-outline-success text-white rounded"
            :class="{'col-4 ms-4' : windowWidth < 480, 'col' : windowWidth > 480}"
            @click="saveSignature"
        >
          {{$t('labels.buttons.shrani')}}
        </button>
        <button
            class="btn btn-outline-warning text-white rounded"
            :class="{'col-4 ms-4' : windowWidth < 480, 'col' : windowWidth > 480}"
            @click="clearSignature"
        >
          {{$t('labels.buttons.pocisti')}}
        </button>
      </div>
    </div>
  </transition>
  <div  class="p-4">
    <h5>{{$t('labels.trenutni')}}</h5>
    <div>
      <img ref="slika" :src="'./img/upload/' + FullUser.podpis + '?t=' + refreshKey"  class="dodan-podpis" :alt="$t('labels.alt')" />
    </div>
  </div>
</template>
<style>
  canvas {
    width: 100%;
    height: 200px;
  }
</style>